const brandNames = [
  "Mercedes-Benz",
  "Volkswagen",
  "BMW",
  "Audi",
  "",
  "Abarth",
  "AC",
  "Acura",
  "Aixam",
  "Alfa Romeo",
  "ALPINA",
  "Artega",
  "Asia Motors",
  "Aston Martin",
  "Austin",
  "Austin Healey",
  "Bentley",
  "Borgward",
  "Brilliance",
  "Bugatti",
  "Buick",
  "Cadillac",
  "Casalini",
  "Caterham",
  "Chatenet",
  "Chevrolet",
  "Chrysler",
  "Citroën",
  "Cobra",
  "Corvette",
  "Dacia",
  "Daewoo",
  "Daihatsu",
  "DeTomaso",
  "Dodge",
  "Donkervoort",
  "DS Automobiles",
  "Ferrari",
  "Fiat",
  "Fisker",
  "Ford",
  "GAC Gonow",
  "Gemballa",
  "GMC",
  "Grecav",
  "Hamann",
  "Holden",
  "Honda",
  "Hummer",
  "Hyundai",
  "Infiniti",
  "Isuzu",
  "Iveco",
  "Jaguar",
  "Jeep",
  "Kia",
  "Koenigsegg",
  "KTM",
  "Lada",
  "Lamborghini",
  "Lancia",
  "Land Rover",
  "Landwind",
  "Lexus",
  "Ligier",
  "Lincoln",
  "Lotus",
  "Mahindra",
  "Maserati",
  "Maybach",
  "Mazda",
  "McLaren",
  "MG",
  "Microcar",
  "MINI",
  "Mitsubishi",
  "Morgan",
  "Nissan",
  "NSU",
  "Oldsmobile",
  "Opel",
  "Pagani",
  "Peugeot",
  "Piaggio",
  "Plymouth",
  "Pontiac",
  "Porsche",
  "Proton",
  "Renault",
  "Rolls-Royce",
  "Rover",
  "Ruf",
  "Saab",
  "Santana",
  "Seat",
  "Skoda",
  "Smart",
  "speedART",
  "Spyker",
  "Ssangyong",
  "Subaru",
  "Suzuki",
  "Talbot",
  "Tata",
  "TECHART",
  "Tesla",
  "Toyota",
  "Trabant",
  "Triumph",
  "TVR",
  "Volvo",
  "Wartburg",
  "Westfield",
  "Wiesmann",
  "Other"
];

export default brandNames;
